import { render } from "./FlagsNotifier.vue?vue&type=template&id=63b54726"
import script from "./FlagsNotifier.vue?vue&type=script&lang=js"
export * from "./FlagsNotifier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__